import type { AxiosResponse } from 'axios'

export const beforeReceive = (
  response: AxiosResponse<unknown>,
): AxiosResponse<unknown> => {
  if (response.headers.authorization) {
    // eslint-disable-next-line no-restricted-syntax
    localStorage.setItem('accessToken', response.headers.authorization)
  }

  return response
}
